export const BookDemoLoader = () => <div className="book-demo-loader" />;
